import React, { useEffect, useState } from 'react';

const MessageListener = () => {
  const [toast, setToast] = useState(null);
  const [prevUnread, setPrevUnread] = useState(0);

  useEffect(() => {
    const checkUnread = async () => {
      const token = localStorage.getItem('token');
      if (!token) return;

      try {
        const res = await fetch('/api/messages/dialogs/', {
          headers: { 'Authorization': `Bearer ${token}` }
        });
        if (res.ok) {
          const dialogs = await res.json();
          const totalUnread = dialogs.reduce((sum, d) => sum + (d.unread_count || 0), 0);

          if (totalUnread > prevUnread && prevUnread > 0) {
            // 🆕 Нашли новое непрочитанное — показываем тост
            const newMsgs = totalUnread - prevUnread;
            setToast({
              text: `💬 Новое сообщение${newMsgs > 1 ? 'и' : ''} (${newMsgs})`,
              time: Date.now()
            });

            // Короткий звук
            const audio = new Audio('data:audio/wav;base64,UklGRl9vT19XQVZFZm10IBAAAAABAAEAQB8AAEAfAAABAAgAZGF0YQAAAAA=');
            audio.volume = 0.3;
            audio.play().catch(() => {});
          }

          setPrevUnread(totalUnread);
        }
      } catch (err) {
        console.error('Ошибка проверки сообщений:', err);
      }
    };

    checkUnread();
    const interval = setInterval(checkUnread, 10000); // каждые 10 сек
    return () => clearInterval(interval);
  }, [prevUnread]);

  // Автоматически скрываем тост через 4 секунды
  useEffect(() => {
    if (toast) {
      const timer = setTimeout(() => setToast(null), 4000);
      return () => clearTimeout(timer);
    }
  }, [toast]);

  if (!toast) return null;

  return (
    <div className="fixed top-6 right-6 z-[99999] animate-in slide-in-from-right fade-in duration-300">
      <div className="bg-slate-900/95 backdrop-blur-xl border border-white/15 text-white px-5 py-3.5 rounded-2xl shadow-[0_10px_40px_rgba(0,0,0,0.5)] flex items-center gap-3">
        <div className="w-2 h-2 rounded-full bg-blue-400 animate-pulse" />
        <span className="text-sm font-semibold">{toast.text}</span>
        <button 
          onClick={() => setToast(null)}
          className="text-slate-400 hover:text-white text-xs ml-2 cursor-pointer"
        >
          ✕
        </button>
      </div>
    </div>
  );
};

export default MessageListener;